/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words per minute uses the standard of 5 characters per word. We count your correctly-typed characters, divide by 5, then divide by the minutes elapsed.`)
};

const es_typing_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las palabras por minuto usan el estándar de 5 caracteres por palabra. Contamos los caracteres que escribiste correctamente, los dividimos entre 5 y luego entre los minutos transcurridos.`)
};

const de_typing_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wörter pro Minute basiert auf dem Standard von 5 Zeichen pro Wort. Wir zählen deine korrekt getippten Zeichen, teilen sie durch 5 und anschließend durch die verstrichenen Minuten.`)
};

const nl_typing_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woorden per minuut gebruikt de standaard van 5 tekens per woord. We tellen je correct getypte tekens, delen dat door 5 en delen het resultaat vervolgens door het aantal verstreken minuten.`)
};

const fr_typing_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les mots par minute utilisent la norme de 5 caractères par mot. Nous comptons vos caractères correctement tapés, divisons par 5, puis divisons par les minutes écoulées.`)
};

const it_typing_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le parole al minuto si basano sullo standard di 5 caratteri per parola. Contiamo i caratteri digitati correttamente, li dividiamo per 5, poi dividiamo per i minuti trascorsi.`)
};

const pt_br2_typing_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavras por minuto usa o padrão de 5 caracteres por palavra. Contamos os caracteres digitados corretamente, dividimos por 5 e depois pelos minutos decorridos.`)
};

const pt_typing_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As palavras por minuto usam o padrão de 5 caracteres por palavra. Contamos os caracteres que escreveu corretamente, dividimos por 5 e depois dividimos pelos minutos decorridos.`)
};

const ja_typing_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM（1分あたりの単語数）は、1単語＝5文字という標準的な基準で計算します。正しく入力できた文字数を5で割り、さらに経過分数で割って算出します。`)
};

const zh_typing_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每分钟字数采用每个单词5个字符的标准。我们统计您正确输入的字符数，除以5，再除以经过的分钟数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_hub_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_hub_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_hub_faq1_a", locale)
	if (locale === "en") return en_typing_hub_faq1_a(inputs)
	if (locale === "es") return es_typing_hub_faq1_a(inputs)
	if (locale === "de") return de_typing_hub_faq1_a(inputs)
	if (locale === "nl") return nl_typing_hub_faq1_a(inputs)
	if (locale === "fr") return fr_typing_hub_faq1_a(inputs)
	if (locale === "it") return it_typing_hub_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_typing_hub_faq1_a(inputs)
	if (locale === "pt") return pt_typing_hub_faq1_a(inputs)
	if (locale === "ja") return ja_typing_hub_faq1_a(inputs)
	return zh_typing_hub_faq1_a(inputs)
};